<template>
  <div class="Component wrapper-cta" :data-cta-align="ctaAlign" v-if="ctaLink">
    <a :href="ctaLink" class="cta-button" :target="ctaTarget">{{ ctaText }}</a>
  </div>
</template>

<script>
export default {
  name: 'CtaButton',
  props: {
    sliceData: {
      type: Object,
      required: true
    },
    prismicLang: {
      type: String,
      required: true
    }
  },
  computed: {
    ctaText() {
      return this.sliceData?.primary?.cta_text || 'Call to Action';
    },
    ctaLink() {
      return this.sliceData?.primary?.cta_link?.url || '#';
    },
    ctaTarget() {
      return this.sliceData?.primary?.cta_link?.target || '_self';
    },
    ctaAlign() {
      // Prismic config: left / center / right (lowercase)
      const align = this.sliceData?.primary?.cta_align || 'left';
      return align.toLowerCase();
    }
  }
};
</script>